/**
 * Creates viewers.
 * @example
 * const deviceviewer = new DeviceViewer();
 * const element = deviceviewer.element;
 */
class DeviceViewer {

    /**
     * Stores the aspect ratio.
     * @type {number}
     * @private
     */
    $aspect;

    /**
     * Stores the viewer container.
     * @type {HTMLElement}
     * @private
     */
    $container;

    /**
     * Stores the canvas element.
     * @type {HTMLCanvasElement}
     * @private
     */
    $element;

    /**
     * Gets the aspect ratio.
     * @type {number}
     * @public
     * @readonly
     */
    get aspect() {

        return this.$aspect;
    }

    /**
     * Gets the canvas element.
     * @type {HTMLCanvasElement}
     * @public
     * @readonly
     */
    get element() {

        return this.$element;
    }

    /**
     * Creates a new viewer.
     */
    constructor() {

        this.$element = document.createElement('canvas');

        this.$element.style.width = '100%';
        this.$element.style.height = '100%';
        // this.$element.style.display = 'block';
        this.$element.style.outline = '0';

        this.setsize();
    }

    /**
     * Appends the viewer to specified container.
     * @param {HTMLElement} $container The container for the canvas element.
     * @public
     */
    appendto($container) {

        this.$container = $container;
        this.$container.appendChild(this.$element);

        this.setsize();
    }

    /**
     * Sets focus on the canvas element.
     * @public
     */
    focus() {

        this.$element.setAttribute('tabindex', '0');
        this.$element.focus();
    }

    /**
     * Gets the device pixel ratio.
     * @returns {number}
     * @public
     */
    ratio() {

        return window.devicePixelRatio || 1;
    }

    /**
     * Sets the size of the viewer.
     * @public
     */
    setsize() {

        const ratio = this.ratio();

        const width = Math.floor(this.$element.offsetWidth * ratio);
        const height = Math.floor(this.$element.offsetHeight * ratio);

        this.$element.setAttribute('width', '' + width);
        this.$element.setAttribute('height', '' + height);

        this.$aspect = this.$element.clientWidth / this.$element.clientHeight;
    }
}

export {

    DeviceViewer
};

export default DeviceViewer;
